import { Controller as e } from "stimulus";
class t extends e {
  initialize() {
    this.autogrow = this.autogrow.bind(this);
  }
  connect() {
    this.element.style.overflow = "hidden";
    const e = this.resizeDebounceDelayValue || 100;
    this.onResize = e > 0 ? function (e, t) {
      var _this = this;
      let i;
      return function () {
        for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
          n[_key] = arguments[_key];
        }
        const s = _this;
        clearTimeout(i), i = setTimeout(() => e.apply(s, n), t);
      };
    }(this.autogrow, e) : this.autogrow, this.autogrow(), this.element.addEventListener("input", this.autogrow), window.addEventListener("resize", this.onResize), 0 == this.element.scrollHeight && (this.element.style.height = `${this.linesCount() * this.lineHeight() + this.getPaddingsSum() + 20}px`);
  }
  disconnect() {
    window.removeEventListener("resize", this.onResize);
  }
  autogrow() {
    this.element.style.height = "auto", this.element.style.height = `${this.element.scrollHeight}px`;
  }
  getStyle(e, t) {
    let i = null;
    return e.currentStyle ? i = e.currentStyle[t] : window.getComputedStyle && (i = document.defaultView.getComputedStyle(e, null).getPropertyValue(t)), i;
  }
  linesCount() {
    return this.element.value.split("\n").length;
  }
  lineHeight() {
    let e = this.getStyle(this.element, "line-height");
    return parseInt(e) || 0;
  }
  getPaddingsSum() {
    let e = 0,
      t = this.getStyle(this.element, "padding-top");
    t && (e += parseInt(t) || 0);
    let i = this.getStyle(this.element, "padding-bottom");
    return i && (e += parseInt(i) || 0), e;
  }
}
t.values = {
  resizeDebounceDelay: Number
};
export default t;